/**
 * @generated SignedSource<<90610e432545a99521a9a593799f479f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useAsyncTaskPollingQuery$variables = {
  taskId: any;
};
export type useAsyncTaskPollingQuery$data = {
  readonly viewer: {
    readonly asyncTask: {
      readonly info: any;
      readonly state: string;
      readonly taskId: any;
    } | null;
  };
};
export type useAsyncTaskPollingQuery = {
  response: useAsyncTaskPollingQuery$data;
  variables: useAsyncTaskPollingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId"
  }
],
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "taskId",
      "variableName": "taskId"
    }
  ],
  "concreteType": "AsyncTask",
  "kind": "LinkedField",
  "name": "asyncTask",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taskId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "info",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAsyncTaskPollingQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAsyncTaskPollingQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "53d01c3b11b4797261f456739d07f2f3",
    "id": null,
    "metadata": {},
    "name": "useAsyncTaskPollingQuery",
    "operationKind": "query",
    "text": "query useAsyncTaskPollingQuery(\n  $taskId: JSON!\n) {\n  viewer {\n    asyncTask(taskId: $taskId) {\n      taskId\n      state\n      info\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "71697eedafe87ae387a92bf29f173dd8";

export default node;
